import { render } from "./AlertTable.vue?vue&type=template&id=3c303c50"
import script from "./AlertTable.vue?vue&type=script&lang=js"
export * from "./AlertTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__